import React from "react";
import { AuthContext } from "types/auth";

export const Context = React.createContext<AuthContext | null>(null);

export default Context;
